import React, { ComponentType } from 'react';
import { Container, Row, Column } from '@uds/grid';
import { Heading02, Heading04 } from '@uds/typography';
import PaddingBox from '@uds/padding-box';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import Ribbon from 'components/ribbons/Ribbon';
import Shortcode, { ShortcodeProps } from 'components/Shortcode';
import visibilitySet from 'presentation/hocs/visibilitySet';
import errorBoundary from 'presentation/hocs/errorBoundary';
import { isNotNilNorEmpty } from 'presentation/utils/generalUtils';

import Questions from './Questions';
import getClassNames from './Elaborate.stylesheet';

export type QuestionProps = {
  question: ShortcodeProps;
  answer: ShortcodeProps;
  defaultOpen?: boolean;
};

type TextProps = {
  title: ShortcodeProps;
  body: ShortcodeProps;
};

interface OuterProps extends RibbonProps {
  items: Array<QuestionProps>;
  text: TextProps;
}

export const getMdColWidth = ({ text }: Partial<OuterProps>) => {
  const hasTitle = isNotNilNorEmpty(text?.title);
  const hasBody = isNotNilNorEmpty(text?.body);

  if (hasTitle || hasBody) {
    return 8;
  }

  return 12;
};

export const PureElaborate = ({ id, layout, colorway, loading, hBaseline = 1, text, items, name }: OuterProps) => {
  const hasTitle = isNotNilNorEmpty(text?.title);
  const hasBody = isNotNilNorEmpty(text?.body);
  const mdColWidth = getMdColWidth({ text });
  const classNames = getClassNames();
  return (
    <Ribbon id={id} colorway={colorway} layout={layout} loading={loading} name={name} type={Type.ELABORATE}>
      <Container>
        <Row>
          {(hasTitle || hasBody) && (
            <Column xs={12} md={4}>
              <PaddingBox component="header" className={classNames.header}>
                {hasTitle && (
                  <Heading02 depth={hBaseline}>
                    <Shortcode code={text.title} against={colorway} />
                  </Heading02>
                )}
                {hasBody && (
                  <Heading04 component="p" className={classNames.body}>
                    <Shortcode code={text.body} against={colorway} />
                  </Heading04>
                )}
              </PaddingBox>
            </Column>
          )}
          <Column xs={12} md={mdColWidth}>
            <Questions colorway={colorway} hBaseline={hBaseline} questions={items} />
          </Column>
        </Row>
      </Container>
    </Ribbon>
  );
};

PureElaborate.displayName = 'Elaborate';

export default errorBoundary(visibilitySet(PureElaborate)) as ComponentType<OuterProps>;
